module.exports = __webpack_public_path__ + "img/logo.1732e4b9.svg";